import React from "react";
import get from "lodash/get";
import WorldCupPageMain from "../../worldcup-2026/WorldCupPage";
import styles from "../../worldcup-2026/WorldCupPage.module.css";

export function WorldCupPage(props) {
    const data = get(props, ["data"], {});
    const { initialData, wcData, isMember, articles } = data;

    return (
        <div className={`custom-page-root ${styles["worldcup-container"]}`}>
            <WorldCupPageMain wcData={wcData || initialData} initialIsMember={isMember} initialArticles={articles} />
        </div>
    );
}

export default WorldCupPage;
